import { environment } from '@coin/shared/core/util-environments';
import { RouteBuilder, RouteSelector, RouteTree, TypedParams } from '../route-builder';
import { EmployeeDetailOverviewModule } from './employee-detail-overview-module';
import { EmploymentConditionLibraryModule } from './employment-condition-library-module';
import { HeadCountApprovalModule } from './headcount-approval-module';
import { HeadcountOverviewModule } from './headcount-overview-module';
import { HomePageModule } from './home-page-module';
import { IncentiveSupportModule } from './incentive-support-module';
import { MercerModule } from './mercer-module';
import { MercerStandingModule } from './mercer-standing-module';
import { MercerSupportModule } from './mercer-support-module';
import { MeritBudgetAllocationModule } from './merit-budget-allocation-module';
import { MeritSupportModule } from './merit-support-module';
import { OrgManagementModule } from './org-management-module';
import { OrgPlanningModule } from './org-planning-module';
import { OrgPlanningSupportModule } from './org-planning-support-module';
import { OrgReviewModule } from './org-review-module';
import { RestructuringModule } from './restructuring-module';
import { SpecialPaymentModule } from './special-payment-module';
import { SuccessionManagementModule } from './succession-management-module';
import { SuccessionManagementSupportModule } from './succession-management-support-module';

const routes = {
  HomePageModule,
  MeritSupportModule,
  OrgPlanningModule,
  MeritBudgetAllocationModule,
  SpecialPaymentModule,
  MercerModule,
  MercerSupportModule,
  MercerStandingModule,
  OrgPlanningSupportModule,
  HeadCountApprovalModule,
  SuccessionManagementModule,
  SuccessionManagementSupportModule,
  EmploymentConditionLibraryModule,
  EmployeeDetailOverviewModule,
  IncentiveSupportModule,
  OrgManagementModule,
  OrgReviewModule,
  RestructuringModule,
  HeadcountOverviewModule
} satisfies RouteTree;
const host = environment.customerUrl;
/** @deprecated Use regular Angular routing with plain string paths instead. Do not register new modules in the RouteBuilder. */
export const Customer = new RouteBuilder(host, routes);
export type CustomerParams<T extends RouteSelector<(typeof Customer)['routes']>> = TypedParams<
  (typeof Customer)['routes'],
  T
>;
